import React, { useMemo } from 'react';
import ProductTemplateStages from 'components/rfq/product-template/rfq-product-template-checklist';
import RFQProductChecklistStore, {
  PageStoreContext,
} from 'store/pages/rfq/rfq-template/rfq-product-checklist/pageStore';

const RFQProductTemplateChecklistPage = (): JSX.Element => {
  const pageStore = useMemo(() => new RFQProductChecklistStore(), []);

  return (
    <PageStoreContext.Provider value={pageStore}>
      <ProductTemplateStages />
    </PageStoreContext.Provider>
  );
};

export default RFQProductTemplateChecklistPage;
